import React from "react";

const Button = ({ styles }) => (
  <a href="#contactUs" className={`py-4 text-center font-poppins font-medium text-[18px] text-[#00040F] hover:opacity-90 bg-blue-gradient rounded-[10px] outline-none ${styles} w-full sm:w-1/3` }>
    Get Started
  </a>
);

export default Button;
